<div class="modal-header">
  <h4 class="modal-title pull-left">{{ isEdit ? 'Edit' : 'Add' }} Contact/ Broker</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="onClose($event)">
      <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form  #contactForm="ngForm">
      <div class="form-group" style="display:none">
          <label class="custom-checkbox">
              <input class="border-checkbox" [(ngModel)]="filterBrokers" (change)="onFilterChange($event)" #chkFilterBrokers="ngModel" name="chkFilterBrokers" id="chkFilterBrokers" type="checkbox">
             Filter brokers by state - {{stateName}}<i></i>
          </label>
      </div>
      <div class="form-group">
          <label class="form-label">Contact Type</label>
          <label class="select">
              <select name="cmbContactType" disabled="{{isEdit}}" required [(ngModel)]="contactTypeId" (change)="bindBrokers()" 
                      #cmbContactType="ngModel" class="form-control ">
                  <option value="0">Select</option>
                  <option *ngFor="let ct of contactTypes" [ngValue]="ct.Id">{{ct.Name}}</option>
              </select>
              <i *ngIf="!isEdit"></i>
          </label>
          <div *ngIf="( contactTypeValid || (cmbContactType.invalid && cmbContactType.touched))">
              <p class="redtext">
                  Contact type is required
              </p>
          </div>
      </div>
      <div class="form-group">
          <label class="form-label">Broker</label>
          <label class="select">
              <select name="cmbBroker" disabled="{{isEdit}}" required (change)="onBrokerChange($event)" [(ngModel)]="brokerId" 
              #cmbBroker="ngModel"
                  class="form-control ">
                  <option value="0">Select</option>
                  <option *ngFor="let broker of brokers" [(ngValue)]="broker.Id">{{broker.Name}}</option>
              </select>
              <i *ngIf="!isEdit"></i>
          </label>
          <div *ngIf="(brokerValid || (cmbBroker.invalid && cmbBroker.touched))">
              <p class="redtext">
                  Broker is required
              </p>
          </div>
      </div>
      <div class="form-group">
          <label class="form-label">Licence</label>
          <label class="select">
              <select name="cmbLicense" (change)="onLicenceSelected($event)" #cmbLicense="ngModel" required
              [(ngModel)]="license" class="form-control ">
                  <option value="0">Select</option>
                  <option *ngFor="let lic of brokerLicenses" [ngValue]="lic.BrokerRegionalLicenseId">{{lic.License}}</option>
              </select>
              <i></i>
          </label>
          <div *ngIf="(licenseValid || (cmbLicense.invalid && cmbLicense.touched))">
              <p class="redtext" >
                  Licence is required
              </p>
          </div>
      </div>

      <div class="text-right">
          <button type="button" (click)="onClose($event)" class="btn btn-default btn-lg">Cancel</button>
          <button type="button" (click)="onSave($event)" class="btn btn-success btn-lg">Save</button>
      </div>
  </form>
</div>
